import React from 'react';
import classNames from 'classnames';

import styles from './styles.sass';

const WaveRule = ({ isInverted }) => (
  <div
    className={classNames(styles.wave, {
      [styles.waveInverted]: isInverted,
    })}
  />
);

export { WaveRule };
